// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"52769686","412":"c4e548ab","484":"5f548e34","565":"cde8ac65"}[chunkId] + ".chunk.js";
};